enum DataEventsEnum {
	Start = 'data.start',
	Loaded = 'data.loaded',
	LoadCache = 'data.load_cache',
	Error = 'data.error',
}

export default DataEventsEnum;
